import React, { useEffect, useState } from 'react'
import { META_BID_STRATEGY, META_BUYING_TYPE, META_OBJECTIVES_TYPE, META_SPECIAL_AD_CATEGORIES } from '../SocialMediaConstant';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import TooltipInfoCard from '../../../components/TooltipInfoCard';
import { useTranslation } from '../../../locale/useTranslation';
import MyMultiSelect from '../../../components/MyMultiSelect';

const MetaCampaignEditForm = (props) => {
    const { dataItem, setDataItem, minSpendCap = "", budgetData } = props;

    const lang = useTranslation();

    const [objectives, setObjectives] = useState([]);
    const [buyingTypes, setBuyingTypes] = useState([]);
    const [bidStrategy, setBidStrategy] = useState([]);
    const [specialAdCategories, setSpecialAdCategories] = useState([]);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        const objectiveRes = Object.keys(META_OBJECTIVES_TYPE).map(key => ({
            _id: META_OBJECTIVES_TYPE[key],
            description: key
        }));
        setObjectives(objectiveRes);

        const buyingTypeRes = Object.keys(META_BUYING_TYPE).map(key => ({
            _id: META_BUYING_TYPE[key],
            description: key
        }));
        setBuyingTypes(buyingTypeRes);

        const bidStrategyRes = Object.keys(META_BID_STRATEGY).map(key => ({
            _id: META_BID_STRATEGY[key],
            description: key
        }));
        setBidStrategy(bidStrategyRes);

        const specialAdCategoriesRes = Object.keys(META_SPECIAL_AD_CATEGORIES).map(key => ({
            _id: META_SPECIAL_AD_CATEGORIES[key],
            description: key
        }));
        setSpecialAdCategories(specialAdCategoriesRes);
    };

    const onChange = (e) => {
        const { name, value, type, checked } = e.target;
        setDataItem({
            ...dataItem,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    return (
        <div className="overflow-hidden" style={{ maxHeight: "calc(100vh - 180px)", marginTop: "-19px" }}>
            <div className="row p-2 mt-2">
                <div className="col-4">
                    <label htmlFor="objective" className="form-label">{lang.objective_label} *
                        <TooltipInfoCard
                            message="Choose what you want people to do when they see your ads. Your campaign objective should align with your overall business goals."
                            link="https://www.facebook.com/business/help/1438417719786914"
                            showLearnMore={true}
                            learnMore="Learn More"
                        />
                    </label>
                    <DropDownList
                        name="objective"
                        textField="description"
                        dataItemKey="_id"
                        data={objectives}
                        value={dataItem.objective}
                        onChange={onChange}
                        className="form-select"
                    />
                </div>
                <div className="col-4">
                    <label htmlFor="buying_type" className="form-label">{lang.buying_type_label} *
                        <TooltipInfoCard
                            message="In Meta Ads Manager, the 'Buying Type' determines how you purchase ad space and how your ads are delivered and billed."
                        />
                    </label>
                    <DropDownList
                        name="buying_type"
                        textField="description"
                        dataItemKey="_id"
                        data={buyingTypes}
                        value={dataItem.buying_type}
                        onChange={onChange}
                        className="form-select"
                    />
                </div>
                <div className="col-4">
                    <label htmlFor="bid_strategy" className="form-label">{lang.bid_strategy_label} *
                        <TooltipInfoCard
                            message="Choose how to distribute your budget across your campaign. Automatically distribute your budget to the best opportunities across your campaign. Also known as Advantage+ campaign budget."
                            link="https://www.facebook.com/business/help/153514848493595?id=629338044106215"
                            showLearnMore={true}
                            learnMore="Learn More"
                        />
                    </label>
                    <DropDownList
                        name="bid_strategy"
                        textField="description"
                        dataItemKey="_id"
                        data={bidStrategy}
                        value={dataItem.bid_strategy}
                        onChange={onChange}
                        className="form-select"
                    />
                </div>
            </div>
            <div className='row p-2'>
                <div className="col-4">
                    <label htmlFor="spend_cap" className="form-label">{lang.spend_cap_label} *</label>
                    <input
                        type="number"
                        name="spend_cap"
                        className="form-control form-control-sm"
                        placeholder="Enter Spend Cap"
                        value={dataItem.spend_cap}
                        onChange={onChange}
                    />
                    <small className="form-text text-muted">
                        {`Minimum Spend Cap >= ${budgetData?.currency?.Description} ${minSpendCap}`}
                    </small>
                </div>
                <div className="col-4">
                    <label htmlFor="daily_budget" className="form-label">{lang.daily_budget_label} *</label>
                    <input
                        type="number"
                        name="daily_budget"
                        className="form-control form-control-sm bg-white"
                        placeholder="Enter Daily Budget"
                        value={dataItem.daily_budget}
                        onChange={onChange}
                    />
                </div>
                <div className="col-4">
                    <label htmlFor="special_ad_categories" className="form-label">{lang.special_ad_categories_label}</label>
                    <MyMultiSelect
                        name="special_ad_categories"
                        textField="description"
                        dataItemKey="_id"
                        data={specialAdCategories}
                        value={dataItem.special_ad_categories}
                        onChange={onChange}
                        isMulti={true}
                        className="form-select"
                    />
                    {dataItem?.special_ad_categories?.length > 2 && <small className="form-text text-muted">You can select a maximum of two categories. </small>}
                </div>
            </div>
        </div>
    );
};


export default MetaCampaignEditForm

